import { type OrderLogReadDto } from "@/config/apiClient";
import { type OrderItemLogActionTypeEnum } from "@/config/apiClient.types";

// Find the last log with the given action type
export const findLastLog = (
  orderItemLogs: OrderLogReadDto[],
  actionType: OrderItemLogActionTypeEnum
) => {
  return orderItemLogs.findLast((log) => log.actionType === actionType);
};
